import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, deleteApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ExcluirMotivoRequest } from './types';

// ACTIONS
import { excluirMotivoSuccess, excluirMotivoFailure } from './actions';

function* excluirMotivo(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: ExcluirMotivoRequest } =
		request;

	const response: ApiResponse = yield call(
		deleteApi,
		token || '',
		PATH_SGU_API,
		`motivos/${payload.id}`,
	);

	if (response.status === 200) {
		yield put(excluirMotivoSuccess(response));
	} else {
		yield put(excluirMotivoFailure());
	}
}

export default all([takeLatest(Types.EXCLUIR_MOTIVO, excluirMotivo)]);
